import React, { useState } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';
import { saveJsonFile, isFileNameUnique } from './localStorageUtils';
import './SaveModal.css';

const SaveModal = ({ isOpen, onClose, jsonContent, onSaveSuccess, isDarkMode }) => {
    const [fileName, setFileName] = useState('');
    const [error, setError] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const handleSave = async () => {
        if (!fileName.trim()) {
            setError('Please enter a file name');
            return;
        }

        if (!isFileNameUnique(fileName)) {
            setError('A file with this name already exists');
            return;
        }

        if (!jsonContent.trim()) {
            setError('No JSON content to save');
            return;
        }

        setIsSaving(true);
        setError('');

        try {
            const result = saveJsonFile(fileName, jsonContent);

            if (result.success) {
                onSaveSuccess && onSaveSuccess(result.file);
                handleClose();
            } else {
                setError(result.error || 'Failed to save file');
            }
        } catch (err) {
            setError('An unexpected error occurred');
        } finally {
            setIsSaving(false);
        }
    };

    const handleClose = () => {
        setFileName('');
        setError('');
        setIsSaving(false);
        onClose();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !isSaving) {
            handleSave();
        } else if (e.key === 'Escape') {
            handleClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>
                        <FaSave className="modal-icon" />
                        Save JSON File
                    </h3>
                    <button className="close-btn" onClick={handleClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="modal-body">
                    <div className="input-group">
                        <label htmlFor="fileName">File Name:</label>
                        <input
                            id="fileName"
                            type="text"
                            value={fileName}
                            onChange={(e) => setFileName(e.target.value)}
                            onKeyDown={handleKeyPress}
                            placeholder="Enter file name..."
                            className="file-name-input"
                            autoFocus
                            disabled={isSaving}
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}
                </div>

                <div className="modal-footer">
                    <button
                        className="cancel-btn"
                        onClick={handleClose}
                        disabled={isSaving}
                    >
                        Cancel
                    </button>
                    <button
                        className="save-btn"
                        onClick={handleSave}
                        disabled={isSaving || !fileName.trim()}
                    >
                        {isSaving ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaveModal;
